

<div id="detail-image" class="mat-dialog-content">
  <img class="closeIcon" (click)="closeModal()" src="assets/icon/icon-exit.svg" />
  <img class="photodetail" src="{{photoUrl}}" alt="photo-detail" />
</div>

